import { InjectionToken } from "@angular/core";

export const STORAGE_SERVICE = new InjectionToken<IStorage>('storage service');
export interface IStorage {
  get(key: string): Promise<any>;
  set(key: string, value: any): Promise<any>;
  remove(key: string): Promise<any>;
}
